import { render, staticRenderFns } from "./emailInput.vue?vue&type=template&id=05bc35a0&"
import script from "./emailInput.vue?vue&type=script&lang=js&"
export * from "./emailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports